const appContainer = {
	display: 'flex',
	maxWidth: {
		sm: '100vw',
		lg: '100vw'
	}
}

export default appContainer
